import {
  showCustomToast,
  updateCustomToast,
} from 'common/components/CustomToast/utils';
import React from 'react';
import { BlockBlobClient } from '@azure/storage-blob';
import { useMutation } from '@apollo/client';

import { UploadFiles } from 'common/components/UploadFiles';
import { DocumentTypeOption } from 'common/components/UploadFiles/view';
import { useFormikContext } from 'formik';
import { Traveler_traveler } from '../../../__generated__/Traveler';
import { TravelerAvailableDocumentTypes } from 'common/graphql/__generated__/TravelerAvailableDocumentTypes';
import {
  TravelerUploadDocument,
  TravelerUploadDocumentVariables,
  TravelerUploadDocument_travelerUploadDocument,
} from 'common/graphql/__generated__/TravelerUploadDocument';
import TRAVELER_UPLOAD_DOCUMENT from 'common/graphql/TravelerUploadDocument.graphql';
interface UploadFormProps {
  availableDocumentTypes: TravelerAvailableDocumentTypes | undefined;
  traveler?: Traveler_traveler;
  onUpload?: (
    fileSelected: File,
    documentData: TravelerUploadDocument_travelerUploadDocument,
    toastId: string
  ) => void;
}
export const UploadForm: React.FC<UploadFormProps> = ({
  availableDocumentTypes,
  traveler,
  onUpload,
}) => {
  const { dirty } = useFormikContext();
  const [uploadDocument] = useMutation<
    TravelerUploadDocument,
    TravelerUploadDocumentVariables
  >(TRAVELER_UPLOAD_DOCUMENT, { errorPolicy: 'all' });

  const { isDraft, id } = { ...traveler };
  const documentTypeOptions =
    availableDocumentTypes?.travelerAvailableDocumentTypes?.nodes.map(
      (doctype) =>
        ({
          key: doctype.id,
          text: doctype.documentType || '',
          isAccountingDocument: doctype.isAccountingDocument,
          title:
            isDraft && doctype.isAccountingDocument
              ? 'Upload prohibited during/after the approval process'
              : undefined,
          disabled: (!isDraft && doctype.isAccountingDocument) || undefined,
        } as DocumentTypeOption)
    ) || [];
  return (
    <UploadFiles
      documentTypes={documentTypeOptions!}
      uploadDocument={{
        uploadDocumentData: async (documentType, data, filSelected) => {
          filSelected.map(async (fileEntity, fileIndex) => {
            //   const toastId = `file.name.${fileEntity?.name}.${fileIndex}`;
            const toastId = showCustomToast({
              content: `Uploading ${fileEntity?.name}...`,
              appearance: 'info',
              autoDismiss: false,
            });
            const uploadMutationResults = await uploadDocument({
              variables: {
                document: {
                  ...data,
                  documentTypeId: parseInt(documentType.key.toString()),
                  filename: fileEntity.name,
                },
                travelerId: id!,
              },
            });
            if (uploadMutationResults.errors) {
              updateCustomToast(toastId!, {
                content: `Upload of ${fileEntity.name} failed`,
                appearance: 'error',
                autoDismiss: true,
              });
            }
            if (
              uploadMutationResults.data?.travelerUploadDocument?.document &&
              uploadMutationResults.data.travelerUploadDocument?.document
                ._documentFileId
            ) {
              onUpload?.(
                fileEntity,
                uploadMutationResults.data.travelerUploadDocument,
                toastId!
              );
              const client = new BlockBlobClient(
                uploadMutationResults.data.travelerUploadDocument?.uploadLink
              );
              await client.uploadData(fileEntity);
            }
          });
        },
      }}
      disableUpload={dirty}
    />
  );
};
